import { ServiceState } from './useService/util/fetchReducer';
import { useNotify } from './useNotify';
import { useCustomCompareEffect } from 'react-use';

function useServiceCallNotify(
  serviceState: ServiceState<any>,
  successMessage: string | null,
  failureMessage: string | null,
) {
  const [addNotification] = useNotify();
  const { isFetching, error, lastFetchAttempt } =
    serviceState || ({} as ServiceState<any>);
  useCustomCompareEffect(
    () => {
      if (!isFetching && !error && lastFetchAttempt && successMessage) {
        addNotification(successMessage, 'success');
      }

      if (!isFetching && error && lastFetchAttempt && failureMessage) {
        addNotification(failureMessage, 'error');
      }
    },
    [
      isFetching,
      error,
      lastFetchAttempt,
      successMessage,
      addNotification,
      failureMessage,
    ],
    ([prevIsFetching], [curIsFetching]) => prevIsFetching === curIsFetching,
  );
}

export default useServiceCallNotify;
